import React from 'react';
import { getSectionIcon, formatSectionTitle } from '../../../utils/formatters';

const ReportTabs = ({ sections, activeTab, onTabChange }) => {
  return (
    <div className="tab-navigation">
      <button
        className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
        onClick={() => onTabChange('overview')}
      >
        📋 Complete Overview
      </button>
      {sections.map((section, index) => (
        <button
          key={index}
          className={`tab-button ${activeTab === `section-${index}` ? 'active' : ''}`}
          onClick={() => onTabChange(`section-${index}`)}
        >
          {getSectionIcon(section.section_type)} {formatSectionTitle(section.section_type)}
        </button>
      ))}
    </div>
  );
};

export default ReportTabs;
